import types from './types';
module.exports = function(h, row) {
    return types.filter(type => type.id == row.type)[0].name;
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/setting/presetreason/type.jsx